import React, { useState, useEffect, useRef } from 'react';
import { executeZaikokanrisihyo } from '../api/api';

function ZaikokanrisihyoPage() {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState('');
  const [logs, setLogs] = useState([]);
  const isClearingRef = useRef(false);

  // statusがnullになったときに確実にクリア
  useEffect(() => {
    if (status === null && isClearingRef.current) {
      setMessage('');
      setLogs([]);
      isClearingRef.current = false;
    }
  }, [status]);

  const handleExecute = async () => {
    
    // 既に実行中の場合は何もしない
    if (loading) {
      return;
    }

    // 前回の実行ログを即座にクリア
    isClearingRef.current = true;
    setStatus(null);
    setMessage('');
    setLogs([]);
    setLoading(true);

    try {
      const result = await executeZaikokanrisihyo();
      setStatus(result.status);

      // ログを設定
      if (result.logs && Array.isArray(result.logs) && result.logs.length > 0) {
        setLogs(result.logs);
      } else {
        setLogs([]);
      }
      
      if (result.status === 'success') {
        let messageText = 'バッチ処理が正常に完了しました。成果物を確認してください。';
        if (result.totalFiles !== undefined && result.processedFiles !== undefined) {
          messageText += `\n【取り込みファイル総数: ${result.totalFiles}件：取り込み完了ファイル数: ${result.processedFiles}件】`;
        }
        if (result.startTime) {
          messageText += `\n実行開始日時: ${result.startTime}`;
        }
        if (result.endTime) {
          messageText += `\n実行終了日時: ${result.endTime}`;
        }
        setMessage(messageText);
      } else if (result.status === 'warning') {
        let messageText = `バッチ処理が完了しましたが、取り込めないデータがあります。`;
        if (result.totalFiles !== undefined && result.processedFiles !== undefined) {
          messageText += `\n【取り込みファイル総数: ${result.totalFiles}件：取り込み完了ファイル数: ${result.processedFiles}件】`;
        }
        if (result.startTime) {
          messageText += `\n実行開始日時: ${result.startTime}`;
        }
        if (result.endTime) {
          messageText += `\n実行終了日時: ${result.endTime}`;
        }
        setMessage(messageText);
      } else if (result.status === 'error') {
        let messageText = `エラーが発生しました。詳細はログを確認してください。`;
        if (result.startTime) {
          messageText += `\n実行開始日時: ${result.startTime}`;
        }
        if (result.endTime) {
          messageText += `\n実行終了日時: ${result.endTime}`;
        }
        setMessage(messageText);
      } else {
        console.log('Unknown status:', result.status);
        const errorMsg = result.message || '不明なエラー';
        let messageText = `エラーが発生しました: ${errorMsg}`;
        if (result.startTime) {
          messageText += `\n実行開始日時: ${result.startTime}`;
        }
        if (result.endTime) {
          messageText += `\n実行終了日時: ${result.endTime}`;
        }
        setMessage(messageText);
      }

    } catch (error) {
      // エラー発生時は前回の状態を完全にクリア
      setStatus('error');
      setLogs([]);
      setMessage('');
      
      // 409エラー（実行中）の場合は特別なメッセージを表示
      if (error.message && error.message.includes('既に実行中')) {
        setMessage(`バッチ処理は既に実行中です。\n他のユーザーが実行中のため、しばらく待ってから再度お試しください。`);
      } else if (error.message.includes('接続できません') || error.message.includes('Failed to fetch')) {
        setMessage(`${error.message}\n\nサーバーを起動するには:\n1. macOS/Linux: ./start-local.sh ／ Windows: .\\start-local.ps1\n2. または手動でサーバーを起動`);
      } else {
        setMessage(`エラーが発生しました: ${error.message || '不明なエラー'}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <h1 className="page-title">常温在庫管理指標</h1>
      <p className="page-description">
        常温在庫管理指標のバッチ処理を実行します
      </p>
      <button
        className="execute-button"
        onClick={(e) => {
          handleExecute();
        }}
        disabled={loading}
      >
        {loading ? '実行中...' : 'バッチ処理を実行'}
      </button>
      {status && (
        <div key={`${status}-${message}-${logs.length}`} className={`status-message ${status}`}>
          {message}
          {logs.length > 0 && (
            <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid rgba(0,0,0,0.1)' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '0.5rem', textAlign: 'left' }}>ログ:</div>
              <div style={{ maxHeight: '300px', overflowY: 'auto', fontSize: '0.9rem', textAlign: 'left' }}>
                {logs.map((log, index) => (
                  <div 
                    key={index} 
                    style={{ 
                      marginBottom: '0.5rem',
                      padding: '0.5rem',
                      fontFamily: 'monospace',
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                      textAlign: 'left'
                    }}
                  >
                    <span style={{ color: '#666', marginRight: '0.5rem' }}>■</span>{log}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ZaikokanrisihyoPage;

